import * as e from "react";
import t from "../lib/IconBase.es.js";
import a from "../defs/Spinner.es.js";
const o = e.forwardRef((r, n) => /* @__PURE__ */ e.createElement(t, { ref: n, ...r, weights: a }));
o.displayName = "SpinnerIcon";
const p = o;
export {
  p as Spinner,
  o as SpinnerIcon
};
